// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  ConfigProvider,
} from 'antd';
import { ApplyPluginsType } from 'umi';
import { getPluginManager } from '../core/plugin';
import { AntdConfigContext, AntdConfigContextSetter } from './context';
import merge from '/Users/shenjiaolong/mn/aism-web-hotcreativeAssistant/node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/merge'

let cacheAntdConfig = null;

const getAntdConfig = () => {
  if(!cacheAntdConfig){
    cacheAntdConfig = getPluginManager().applyPlugins({
      key: 'antd',
      type: ApplyPluginsType.modify,
      initialValue: {
        ...{"theme":{"components":{"Collapse":{"contentBg":"fff","headerBg":"#f8f8f8"},"Menu":{"itemActiveBg":"#F7F8F9","itemColor":"#666666","itemBorderRadius":0},"Button":{"textHoverBg":"#f5f5f5","defaultActiveColor":"#0346FE"},"Table":{"headerColor":"#333333","borderColor":"#EEEEEE","headerBg":"#ECEFF5","cellPaddingBlock":7},"Pagination":{"itemActiveBg":"#1755FE"},"Drawer":{"footerPaddingInline":"20px","footerPaddingBlock":"16px"},"Input":{"hoverBg":"#ffffff","hoverBorderColor":"#EEEEEE","activeBorderColor":"#0346FE","activeShadow":"transparent"},"InputNumber":{"hoverBg":"#ffffff","hoverBorderColor":"#EEEEEE","activeBorderColor":"#0346FE","activeShadow":"transparent","addonBg":"#f5f5f5"},"Form":{"labelColor":"#666666"},"Select":{"selectorBg":"#FFFFFF","optionSelectedBg":"#f5f5f5","optionSelectedColor":"#333333"},"Tree":{"nodeSelectedBg":"#f8f8f8","titleHeight":"32px"},"Switch":{"trackHeight":14,"handleSize":10,"trackMinWidth":28}},"token":{"colorText":"#333333","borderRadius":4,"colorPrimary":"#0346FE","colorPrimaryActive":"#356BFE","colorPrimaryHover":"#0238CB","colorLink":"#0346FE","colorLinkActive":"#356BFE","colorLinkHover":"#0238CB","fontFamily":"SourceHanSansLight"}}},
      },
    });
    if (!cacheAntdConfig.theme) {
      cacheAntdConfig.theme = {};
    }
  }
  return cacheAntdConfig;
}

function AntdProvider({ children }) {
  let container = children;

  const [antdConfig, _setAntdConfig] = React.useState(() => {
    const {
      appConfig: _,
      ...finalConfigProvider
    } = getAntdConfig();
    return finalConfigProvider
  });
  const setAntdConfig: typeof _setAntdConfig = (newConfig) => {
    _setAntdConfig(prev => {
      return merge({}, prev, typeof newConfig === 'function' ? newConfig(prev) : newConfig)
    })
  }


  if (antdConfig.prefixCls) {
    ConfigProvider.config({
      prefixCls: antdConfig.prefixCls,
    });
  };

  if (antdConfig.iconPrefixCls) {
    // Icons in message need to set iconPrefixCls via ConfigProvider.config()
    ConfigProvider.config({
      iconPrefixCls: antdConfig.iconPrefixCls,
    });
  };

  if (antdConfig.theme) {
    // Pass config theme to static method
    ConfigProvider.config({
      theme: antdConfig.theme,
    });
  }

  container = <ConfigProvider {...antdConfig}>{container}</ConfigProvider>;


  container = (
    <AntdConfigContextSetter.Provider value={setAntdConfig}>
      <AntdConfigContext.Provider value={antdConfig}>
        {container}
      </AntdConfigContext.Provider>
    </AntdConfigContextSetter.Provider>
  )

  return container;
}

export function rootContainer(children) {
  return (
    <AntdProvider>
      {children}
    </AntdProvider>
  );
}
